import React from 'react';
import { motion } from 'framer-motion';
import { COLORS } from './theme';

// Gold ornament divider: line — diamond — line.
// `draw` animates the lines drawing outward (used under the masthead).
const GoldDivider: React.FC<{ draw?: boolean; className?: string }> = ({
  draw = false,
  className = '',
}) => {
  const line = (side: 'left' | 'right') => {
    const style: React.CSSProperties = {
      height: '1px',
      background:
        side === 'left'
          ? `linear-gradient(90deg, transparent, ${COLORS.goldLeaf})`
          : `linear-gradient(90deg, ${COLORS.goldLeaf}, transparent)`,
    };
    if (!draw) return <span className="flex-1" style={style} />;
    return (
      <motion.span
        className="flex-1"
        style={{ ...style, transformOrigin: 'center' }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.6, delay: 0.5, ease: [0.22, 0.61, 0.36, 1] }}
      />
    );
  };

  return (
    <div
      className={`flex items-center justify-center gap-3.5 mx-auto w-[min(320px,70%)] ${className}`}
      aria-hidden="true"
    >
      {line('left')}
      <span
        className="flex-none w-[7px] h-[7px] rotate-45"
        style={{
          background: `linear-gradient(135deg, ${COLORS.goldLeaf}, ${COLORS.goldLeafDark})`,
          boxShadow: '0 0 6px rgba(197,165,90,0.5)',
        }}
      />
      {line('right')}
    </div>
  );
};

export default GoldDivider;
